/**
 * Organization settings for the mockup tenant.
 * One object — the firm-wide configuration displayed on Settings › Organization.
 */

export interface OrgSettings {
  id: string;
  name: string;
  slug: string;
  timezone: string;
  minutesPerScreenshot: number;
  fullDayThresholdHours: number;
  halfDayThresholdHours: number;
  halfDayWeight: number;
  /** 104e D2 — org opt-in for auto-inviting newly-discovered employees. */
  autoInviteOnEmployeeDiscovery: boolean;
  /**
   * Task 110 D4 — opt-in domain used by the Insightful sync to synthesize
   * `${username}@${domain}` for employees whose Insightful `user` lacks an
   * `@`. Null means synthesis is disabled (default; conservative).
   */
  insightfulEmailDomain: string | null;
  workWeek: { start: string; end: string };
}

export const ORG_SETTINGS: OrgSettings = {
  id: 'org-meridian',
  name: 'Meridian Associates',
  slug: 'meridian',
  timezone: 'America/New_York',
  minutesPerScreenshot: 10,
  fullDayThresholdHours: 6.0,
  halfDayThresholdHours: 3.0,
  halfDayWeight: 0.5,
  autoInviteOnEmployeeDiscovery: false,
  insightfulEmailDomain: null,
  workWeek: { start: 'Monday', end: 'Friday' },
};
